import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { Save, Trash2 } from "lucide-react";

export default function EditExperience({ data, idCv }) {
    const [experience, setExperience] = useState({
        societe: '',
        dateExp: '',
        dateFin: '',
        descriptionExp: ''
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const navigate = useNavigate();

    // Déstructuration de l'objet `experience`
    const { societe, dateExp, dateFin, descriptionExp } = experience;

    useEffect(() => {
        getExperience();
    }, [data]);

    const getExperience = useCallback(async () => {
        try {
            const { data: expData } = await axios.get(`experiences/${data}`);
            if (expData) {
                setExperience({
                    societe: expData.societe || '',
                    dateExp: expData.datexp || '',
                    dateFin: expData.datefin || '',
                    descriptionExp: expData.descriptionexp || ''
                });
            }
        } catch (error) {
            handleError('Erreur lors de la récupération des données');
        }
    }, [data]);

    const editExperience = useCallback(async () => {
        const { societe, dateExp, dateFin, descriptionExp } = experience;

        if (!societe && !dateExp && !descriptionExp && !dateFin) {
            NotificationManager.warning('Aucune modification enregistrée', 'Avertissement', 4000);
            return;
        }

        const formData = new FormData();
        formData.append('societe', societe);
        formData.append('datexp', dateExp);
        formData.append('descriptionexp', descriptionExp);
        formData.append('datefin', dateFin);

        try {
            const resp = await axios.put(`experiences/${data}`, formData);
            if (resp.status === 200) {
                NotificationManager.success('Modification réussie', 'Succès', 4000);
                window.location.reload();
            }
        } catch (error) {
            handleError('Erreur lors de la modification');
        }
    }, [experience, data]);

    const deleteExperience = async () => {
        try {
            const resp = await axios.delete(`experiences/${data}`);
            if (resp.status === 204) {
                NotificationManager.success('Expérience supprimée avec succès', 'Succès', 4000);
                // navigate(`/editCv/${idCv}`);
                window.location.reload();
            }
        } catch (error) {
            handleError('Erreur lors de la suppression');
        }
    };

    const handleError = (message) => {
        console.error(message);
        NotificationManager.error(message, 'Erreur', 4000);
    };

    const handleChange = (e) => {
        setExperience({
            ...experience,
            [e.target.name]: e.target.value
        });
    };

    const years = Array.from({ length: 51 }, (_, i) => (1990 + i).toString());

    return (
        <>
            <form>
                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Société</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                        <input
                            type="text"
                            name="societe"
                            className="form-control"
                            value={societe}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Dates d'expérience</h6>
                    </div>
                    <div className="col-sm-4 text-secondary">
                        <select
                            name="dateExp"
                            className="form-control"
                            value={dateExp}
                            onChange={handleChange}
                        >
                            {years.map((year) => (
                                <option value={year} key={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-sm-5 text-secondary">
                        <select
                            name="dateFin"
                            className="form-control"
                            value={dateFin}
                            onChange={handleChange}
                        >
                            {years.map((year) => (
                                <option value={year} key={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Description du poste</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                        <textarea
                            name="descriptionExp"
                            className="form-control"
                            value={descriptionExp}
                            rows={4}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-9 text-secondary">
                        <div className="btn-group" role="group" aria-label="Actions">
                            <button
                                type="button"
                                onClick={editExperience}
                                className="btn btn-primary"
                            >
                                <Save size={20} strokeWidth={1.5} />&nbsp;
                                Enregistrer les modifications
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowConfirm(true)}
                                className="btn btn-danger"
                            >
                                <Trash2 size={20} strokeWidth={1.5} />&nbsp;
                                Supprimer
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            {/* Confirmation Modal */}
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>Êtes-vous sûr de vouloir supprimer cette expérience ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={deleteExperience}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
